import { FC } from "react";

/**
 * Warning Icon Props Interface
 * @interface SortByProps
 */

interface SortByProps {
  /** display fill of the icon */
  fill?: string;
  sort_order?: string;
}

const SortBy: FC<SortByProps> = ({ fill = "#E0E0E0", sort_order }) => {
  const sortOrderClass = sort_order === "asc" ? "rotate-180" : "";
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={`min-w-24px ${sortOrderClass}`}
    >
      <path
        d="M10 18H14V16H10V18ZM3 6V8H21V6H3ZM6 13H18V11H6V13Z"
        fill={fill}
      />
    </svg>
  );
};

export default SortBy;
